import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { invoicesRestCrudThunksForBuyer } from '../../thunks/invoices_thunks';
import { EditPage } from '../edit_page/EditPage';
import BuyerInvoiceForm from '../buyer_invoice_form/BuyerInvoiceForm';
import { getEntityById } from '../../utils/DataAccessUtils';

const style = require('./EditBuyerInvoicePage.less');
const queryString = require('qs');

class EditBuyerInvoicePage extends React.Component<any, any> {
	state = {
		invoice: {},
		fetching: true,
	};

	componentDidMount() {
		const { getInvoice, match } = this.props;
		const invoiceId = match.params.id;
		this.setState({ fetching: true });
		getInvoice(invoiceId)
			.then((invoice) => {
				this.setState({ invoice, fetching: false });
			})
			.catch(() => {
				this.setState({ fetching: false });
			});
	}

	render() {
		const { history, location } = this.props;
		const { invoice, fetching } = this.state;

		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		//noinspection TypeScriptUnresolvedVariable
		return [
			<EditPage
				title={`Edit Invoice ${invoice.id}`}
				formComponentProps={{
					formData: invoice,
					onSuccess: (rec) => {
						if (!!queryParams.btwo) {
							history.push(`/buyer/workOrders/detail/${rec.workOrderId}/invoices`);
						} else {
							history.push(`/buyer/invoices/detail/${rec.id}`);
						}
					},
				}}
				fetching={fetching}
				FormComponent={BuyerInvoiceForm}
			/>,
		];
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		invoice: getEntityById(ownProps.match.params.id, state.invoices),
		fetching: state.invoices.fetching,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getInvoice: (id) => dispatch(invoicesRestCrudThunksForBuyer.readOne(id)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(EditBuyerInvoicePage)
);
